/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ChangeEvent, useEffect, useState } from 'react'
import '../../../modules/apps/ordenes-management/users-list/user-edit-modal/ProductModule/styles/custom-styles.css';
import { ILayout, LayoutSetup, getLayoutFromLocalStorage } from '../../../../_metronic/layout/core'
import { useShoppingCart } from '../../../modules/apps/ordenes-management/users-list/user-edit-modal/ProductModule/hooks/useShoppingCart'
import { ProductCard, ProductImage, ProductNombre, ProductButtons, ProductPrecio } from '../../../modules/apps/ordenes-management/users-list/user-edit-modal/ProductModule/components'
import { getAuth } from '../../../modules/auth'
import { SERVICIOS_API } from '../../../../_metronic/helpers/crud-helper/consts';
import axios from 'axios';
import { Product } from '../../../modules/apps/ordenes-management/users-list/user-edit-modal/ProductModule/interfaces/interfaces';

type DatosFiscales = {
  id: number
  nombre: string
  registro: string
  direccion: string
}

type Sucursal = {
  id: number
  nombre: string
  pais: string
  estadoSucursal: string
  ciudad: string
  direccion: string
}

type Pais = {
  id: number;
  nombre: string;
};

type Estado = {
  id: number;
  nombre: string;
  paisId: number;
};

type Ciudad = {
  id: number;
  nombre: string;
  estadoId: number;
};
interface DescuentoAplicado {
  porcentaje: number;
  nuevoPrecio: number;
}

interface CodigoDescuentoState {
  [productId: string]: string;
}

const ListProduct: React.FC = () => {
  const [config, setConfig] = useState<ILayout>(getLayoutFromLocalStorage())
  const [configLoading, setConfigLoading] = useState<boolean>(false)

  const usuario = getAuth();
  const API_URL = process.env.REACT_APP_API_URL;

  ///////////////////////////////////////////////////////////////////////////////////////////
  /**
   * DATOS FISCALES EXISTENTES
   */
  //////////////////////////////////////////////////////////////////////////////////////////
  const [datosFiscales, setDatosFiscales] = useState<DatosFiscales[] | undefined>(undefined);
  const [datosFiscalesSeleccionada, setDatosFiscalesSeleccionada] = useState<string>('');
  const [nombreFiscal, setNombreFiscal] = useState<string>('');
  const [registroFiscal, setRegistroFiscal] = useState<string>('');
  const [direccionFiscal, setDireccionFiscal] = useState<string>('');


  useEffect(() => {
    const FISCALES_URL = API_URL + SERVICIOS_API.URL_FISCALES
    axios.get(FISCALES_URL, {
      headers: {
        'x-token': `${usuario?.api_token}`,
      },
    }).then((response) => {
      setDatosFiscales(response.data.data)
    })
  }, [])

  const handleFiscalChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    setDatosFiscalesSeleccionada(selectedValue);

    const selectedFiscal = datosFiscales?.find((datoFiscal) => datoFiscal.id?.toString() === selectedValue);

    if (selectedFiscal) {
      setNombreFiscal(selectedFiscal.nombre);
      setRegistroFiscal(selectedFiscal.registro);
      setDireccionFiscal(selectedFiscal.direccion);
    } else {
      // Si es 'Personalizado', puedes limpiar o establecer valores predeterminados
      setNombreFiscal('');
      setRegistroFiscal('');
      setDireccionFiscal('');
    }
  };

  ///////////////////////////////////////////////////////////////////////////////////////////
  /**
   * DATOS FISCALES NUEVO
   */
  //////////////////////////////////////////////////////////////////////////////////////////
  const [nombreFiscalIngresada, setNombreFiscalIngresada] = useState('');
  const [registroFiscalIngresada, setRegistroFiscalIngresada] = useState('');
  const [direccionFiscalIngresada, setDireccionFiscalIngresada] = useState('');

  ///////////////////////////////////////////////////////////////////////////////////////////
  /**
   * DATOS SUCURSALES POR EXISENTES
   */
  //////////////////////////////////////////////////////////////////////////////////////////
  const [sucursales, setSucursales] = useState<Sucursal[] | null>(null);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState<string>(''); // Cambiado a string
  const [nombre, setNombre] = useState<string>('');
  const [pais, setPais] = useState<string>('');
  const [estado, setEstado] = useState<string>('');
  const [ciudad, setCiudad] = useState<string>('');
  const [direccion, setDireccion] = useState<string>('');

  useEffect(() => {
    const SUCURSALES_URL = API_URL + SERVICIOS_API.URL_SUCURSAL
    axios.get(`${SUCURSALES_URL}/?activo=true`, {
      headers: {
        'x-token': `${usuario?.api_token}`,
      },
    }).then((response) => {
      setSucursales(response.data.data);
    });
  }, []);

  function handleSucursalChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const selectedValue = event.target.value;
    setSucursalSeleccionada(selectedValue);

    const selectedSucursal = sucursales?.find((sucursal) => sucursal.id.toString() === selectedValue);

    if (selectedSucursal) {
      setNombre(selectedSucursal.nombre);
      setPais(selectedSucursal.pais);
      setEstado(selectedSucursal.estadoSucursal);
      setCiudad(selectedSucursal.ciudad);
      setDireccion(selectedSucursal.direccion);
    } else {
      // Si es 'Personalizado', puedes limpiar o establecer valores predeterminados
      setNombre('');
      setPais('');
      setEstado('');
      setCiudad('');
      setDireccion('');
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  /**
   * DATOS SUCURSAL NUEVO
   */
  //////////////////////////////////////////////////////////////////////////////////////////
  const [nombreIngresada, setNombreIngresada] = useState('');
  const [paises, setPaises] = useState<Pais[] | null>();
  const [estados, setEstados] = useState<Estado[] | null>();
  const [ciudades, setCiudades] = useState<Ciudad[] | null>();
  const [paisSeleccionado, setPaisSeleccionado] = useState<number | null>(null);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState<number | null>(null);
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState<number | null>(null);

  useEffect(() => {
    axios.get(`${API_URL}/paises`).then((response) => {
      const paisesOrdenados = response.data.paises.sort((a: Pais, b: Pais) => a.nombre.localeCompare(b.nombre));
      setPaises(paisesOrdenados);
    });
  }, []);


  useEffect(() => {
    // Hacer la petición para obtener los estados cuando se selecciona un país
    if (paisSeleccionado !== null) {
      axios.get(`${API_URL}/estado/${paisSeleccionado}`)
        .then((response) => {
          const estadosOrdenados = response.data.estados.sort((a: Estado, b: Estado) => a.nombre.localeCompare(b.nombre));
          setEstados(estadosOrdenados);
        });
    } else {
      // Si no hay un país seleccionado, reseteamos la lista de estados
      setEstados(null);
    }
  }, [paisSeleccionado]);

  useEffect(() => {
    // Hacer la petición para obtener las ciudades cuando se selecciona un estado
    if (estadoSeleccionado !== null) {
      axios.get(`${API_URL}/ciudad/${estadoSeleccionado}`)
        .then((response) => {
          const ciudadesOrdenadas = response.data.ciudades.sort((a: Ciudad, b: Ciudad) => a.nombre.localeCompare(b.nombre));
          setCiudades(ciudadesOrdenadas);
        });
    } else {
      // Si no hay un estado seleccionado, reseteamos la lista de ciudades
      setCiudades(null);
    }
  }, [estadoSeleccionado]);

  const handlePaisChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = parseInt(event.target.value, 10);
    console.log(event.target.value)
    setPaisSeleccionado(selectedId);
    setEstadoSeleccionado(null);
    setCiudadSeleccionada(null); // Resetear la ciudad seleccionada al cambiar de país
  };

  const handleEstadoChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = parseInt(event.target.value, 10);
    setEstadoSeleccionado(selectedId);
    setCiudadSeleccionada(null); // Resetear la ciudad seleccionada al cambiar de estado
  };

  const handleCiudadChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = parseInt(event.target.value, 10);
    setCiudadSeleccionada(selectedId);
  };

  const [direccionIngresada, setDireccionIngresada] = useState('');

  ///////////////////////////////////////////////////////////////////////////////////////////
  /**
   * PRODUCTOS
   */
  //////////////////////////////////////////////////////////////////////////////////////////

  const { shoppingCart, onProductCountChange } = useShoppingCart();

  const [items, setItems] = useState<Product[] | undefined>(undefined);
  useEffect(() => {

    getProductos();
  }, []);
  const getProductos = async () => {
    const API_URL = process.env.REACT_APP_API_URL;
    try {
      const result = await axios.get(`${API_URL}/producto?activo=true`, {
        headers: {
          'x-token': `${usuario?.api_token}`,
        },
      });
      setItems(result.data.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  let ejemplo = {}
  console.log(shoppingCart)

  ///////////////////////////////////////////////////////////////////////////////////////////
  /**
   * FRAGMENTO DE DESCUENTO POR PRODUCTO
   */
  //////////////////////////////////////////////////////////////////////////////////////////
  const [codigosDescuento, setCodigosDescuento] = useState<CodigoDescuentoState>({});
  const [descuentosAplicados, setDescuentosAplicados] = useState<Record<string, DescuentoAplicado | null>>({});

  const handleCodigoDescuentoChange = (productId: string, event: ChangeEvent<HTMLInputElement>) => {
    setCodigosDescuento((prevCodigosDescuento) => ({
      ...prevCodigosDescuento,
      [productId]: event.target.value,
    }));
  };

  const handleAplicarDescuento = async (productId: string, product: Product) => {
    try {
      const codigoDescuento = codigosDescuento[productId];

      if (!codigoDescuento) {
        console.error('No se ha ingresado un código de descuento para el producto.');
        return;
      }

      const response = await axios.get(`https://dashboard.gc-track.com/api/descuento/descuentoProducto?ProductoId=${productId}&codigo=${codigoDescuento}`, {
        headers: {
          'x-token': `${usuario?.api_token}`,
        },
      });
      const porcentajeDescuento = response.data.respuesta.descuento[0].cantidad;
      console.log(response.data.respuesta.descuento[0].cantidad)

      const precioOriginal = product.precio_lista;
      const descuentoCalculado = (precioOriginal! * porcentajeDescuento) / 100;
      const nuevoPrecio = precioOriginal! - descuentoCalculado;

      console.log({ porcentajeDescuento }, { precioOriginal }, { descuentoCalculado }, { nuevoPrecio }, { response })

      // Almacenar el descuento aplicado en el estado
      setDescuentosAplicados((prevDescuentos) => ({
        ...prevDescuentos,
        [productId]: {
          porcentaje: porcentajeDescuento,
          nuevoPrecio: nuevoPrecio,
        },
      }));

      // Resto de la lógica...

    } catch (error) {
      console.error('Error al obtener el descuento:', error);
      // Manejar el error según tus necesidades
    }
  };

  ///////////////////////////////////////////////////////////////////////////////////////////
  /**
   * RESULTADOS DE PEDIDO
   */
  //////////////////////////////////////////////////////////////////////////////////////////
  const descuentoCupones = Object.entries(shoppingCart).reduce((acc, product) => acc + product[1].precio_lista * product[1].count, 0) - Object.entries(shoppingCart).reduce((acc, [productId, product]) =>
    acc + (descuentosAplicados[productId]?.nuevoPrecio || product.precio_lista) * product.count, 0);
  const subtotal = Object.entries(shoppingCart).reduce((acc, [productId, product]) =>
    acc + (descuentosAplicados[productId]?.nuevoPrecio || product.precio_lista) * product.count, 0);
  // const subtotal = Object.entries(shoppingCart).reduce((acc, product) => acc + product[1].precio_lista * product[1].count, 0)
  const descuentoFinal = subtotal * (usuario?.usuarioGc_Track?.factorMultiplicador! - 1)
  const total = subtotal + descuentoFinal

  ///////////////////////////////////////////////////////////////////////////////////////////
  /**
   * CREAR ORDEN
   */
  //////////////////////////////////////////////////////////////////////////////////////////



  const updateConfig = () => {
    setConfigLoading(true)

    try {
      LayoutSetup.setConfig(config)
      window.location.reload()
    } catch (error) {
      setConfig(getLayoutFromLocalStorage())
      setConfigLoading(false)
    }
  }

  return (
    <>
      <div>
        {/* <DatosConfirmacion /> */}
        <div className='d-flex flex-row justify-content-between'>
          <div className='col-3 d-flex flex-column justify-content-between px-5'>
            <div className='card-header border-4 py-3 border-0 d-flex justify-content-center'>
              <h3 className='fw-bolder fs-1 m-0'> Datos del Solicitante </h3>
            </div>
            <div className="form-floating col-12 mb-3 d-flex justify-content-between">
              <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={usuario?.usuarioGc_Track?.nombreCompleto} disabled />
              <label htmlFor="inputNombre">Nombre</label>
            </div>
            <div className="form-floating col-12 mb-3 d-flex justify-content-between">
              <input type="email" className="form-control fs-5 ps-3 form-control-solid" value={usuario?.usuarioGc_Track?.correo} disabled />
              <label htmlFor="inputCorreo">Correo</label>
            </div>
            <div className="form-floating col-12 mb-3 d-flex justify-content-between">
              <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={usuario?.usuarioGc_Track?.organizacion} disabled />
              <label htmlFor="inputEmpresa">Empresa</label>
            </div>

          </div>
          <div className='col-3 d-flex flex-column justify-content-between px-5'>
            <div className='card-header border-4 py-3 border-0 d-flex justify-content-center'>
              <h3 className='fw-bolder fs-1 m-0'> Datos Fiscales </h3>
            </div>
            <div className='form-floating col-12 mb-3 me-2 pe-1 d-flex justify-content-between'>
              <select id="floatingRazonSocial" className='form-select form-select-solid ' data-kt-select2='true' data-placeholder='Razón Social' data-allow-clear='true' data-kt-user-table-filter='Razón'
                data-hide-search='false' value={datosFiscalesSeleccionada} onChange={handleFiscalChange}>
                <option value="">Personalizado</option>
                {datosFiscales?.map((datoFiscal) => (
                  <option key={datoFiscal.id} value={datoFiscal.id?.toString()}>
                    {datoFiscal.nombre}
                  </option>
                ))}
              </select>
              <label htmlFor="floatingSucursal">Razón Social</label>
            </div>
            {datosFiscalesSeleccionada !== "" ?
              <>
                <div className='d-flex flex-row'>
                  <div className="form-floating col-8 mb-3 pe-1 d-flex justify-content-between">
                    <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={nombreFiscal} disabled />
                    <label htmlFor="inputNombre">Razón Social</label>
                  </div>
                  <div className="form-floating col-4 mb-3 pe-1 d-flex justify-content-between">
                    <input type="email" className="form-control fs-5 ps-3 form-control-solid" value={registroFiscal} disabled />
                    <label htmlFor="inputCorreo">Registro</label>
                  </div>
                </div><div className="form-floating col-12 mb-3 pe-1 d-flex justify-content-between">
                  <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={direccionFiscal} disabled />
                  <label htmlFor="inputEmpresa">Dirección</label>
                </div>
              </>
              :
              <>
                <div className='d-flex flex-row'>
                  <div className="form-floating col-8 mb-3 pe-1 d-flex justify-content-between">
                    <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={nombreFiscalIngresada} onChange={e => setNombreFiscalIngresada(e.target.value)} />
                    <label htmlFor="inputNombre">Razón Social</label>
                  </div>
                  <div className="form-floating col-4 mb-3 pe-1 d-flex justify-content-between">
                    <input type="email" className="form-control fs-5 ps-3 form-control-solid" value={registroFiscalIngresada} onChange={e => setRegistroFiscalIngresada(e.target.value)} />
                    <label htmlFor="inputCorreo">Registro</label>
                  </div>
                </div><div className="form-floating col-12 mb-3 pe-1 d-flex justify-content-between">
                  <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={direccionFiscalIngresada} onChange={e => setDireccionFiscalIngresada(e.target.value)} />
                  <label htmlFor="inputEmpresa">Dirección</label>
                </div>
              </>
            }


          </div>
          <div className='col-6 d-flex flex-column justify-content-between px-5'>
            <div className='card-header border-4 py-3 border-0 d-flex justify-content-center'>
              <h3 className='fw-bolder fs-1 m-0'> Datos del Envío </h3>
            </div>
            <div className='d-flex flex-row'>
              <div className='form-floating col-6 mb-3 me-2 pe-1 d-flex justify-content-between'>
                {/* <select id="floatingSucursal" className='form-select form-select-solid ' data-kt-select2='true' data-placeholder='Sucursal' data-allow-clear='true' data-kt-user-table-filter='Sucursal'
                  data-hide-search='false' onChange={(e) =>
                    console.log("evento", e.target)
                    //setSucursalSeleccionado(e.target.value)

                  } value={"sucursalSeleccionado"}>
                  <option value="Personalizado">Personalizado</option>

                  {sucursales?.map((sucursal, index) =>
                    <option key={index} value={sucursal.nombre}>{sucursal.nombre}</option>
                  )}
                </select> */}
                <select id="floatingSucursal" className='form-select form-select-solid ' data-kt-select2='true' data-placeholder='Sucursal' data-allow-clear='true' data-kt-user-table-filter='Sucursal'
                  data-hide-search='false' value={sucursalSeleccionada} onChange={handleSucursalChange}>
                  <option value="">Personalizado</option>
                  {sucursales?.map((sucursal) => (
                    <option key={sucursal.id} value={sucursal.id.toString()}>
                      {sucursal.nombre}
                    </option>
                  ))}
                </select>

                <label htmlFor="floatingSucursal">Sucursal</label>
                {/* <input list="opciones" value={sucursal || ''} onChange={(e) => setSucursal(e.target.value)} className="form-control form-control-solid" id="TuComponenteDatalist" />
                <label htmlFor="TuComponenteDatalist">Pais</label>
                <datalist id="opciones">
                  {datosFiscalesSelect.map((opcion) => (
                    <option key={opcion.value} value={opcion.value} />
                  ))}
                </datalist> */}
                {/* <Select options={datosFiscalesSelect} placeholder="Razón Social" styles={estiloSelect}></Select> */}
              </div>
              {sucursalSeleccionada !== "" ?
                <div className="form-floating col-6 mb-3 d-flex justify-content-between">
                  <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={nombre} disabled />
                  <label htmlFor="inputNombre">Nombre Sucursal</label>
                </div> :
                <div className="form-floating col-6 mb-3 d-flex justify-content-between">
                  <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={nombreIngresada} onChange={e => setNombreIngresada(e.target.value)} />
                  <label htmlFor="inputEmpresa">Nombre Sucursal</label>
                </div>
              }
            </div>
            <div className='d-flex flex-row'>
              {sucursalSeleccionada !== "" ?
                <>
                  <div className="form-floating col-4 mb-3 me-2 pe-1 d-flex justify-content-between">
                    <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={pais} disabled />
                    <label htmlFor="inputEmpresa">Pais</label>
                  </div><div className="form-floating col-4 mb-3 me-2 pe-1 d-flex justify-content-between">
                    <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={estado} disabled />
                    <label htmlFor="inputEmpresa">Estado o Provincia</label>
                  </div><div className="form-floating col-4 mb-3 me-2 pe-1 d-flex justify-content-between">
                    <input type="text" className="form-control fs-5 ps-3 form-control-solid" value={ciudad} disabled />
                    <label htmlFor="inputEmpresa">Ciudad</label>
                  </div>
                </>
                :
                <>
                  <div className='form-floating col-4 mb-3 me-2 pe-1 d-flex justify-content-between'>
                    <select id="floatingPais" className='form-select form-select-solid ' data-kt-select2='true' data-placeholder='País' data-allow-clear='true' data-kt-user-table-filter='País'
                      data-hide-search='false' value={paisSeleccionado || ''} onChange={handlePaisChange}>
                      {paises && paises.map((pais) => (
                        <option key={pais.id} value={pais.id}>{pais.nombre}</option>
                      ))}
                    </select>
                    <label htmlFor="floatingPais">País</label>
                  </div><div className='form-floating col-4 mb-3 me-1 pe-1 d-flex justify-content-between'>
                    <select id="floatingEstado" className='form-select form-select-solid ' data-kt-select2='true' data-placeholder='Estado' data-allow-clear='true' data-kt-user-table-filter='Estados'
                      data-hide-search='true' value={estadoSeleccionado || ''} onChange={handleEstadoChange} disabled={!estados}>
                      <option value="" disabled>Selecciona un estado</option>
                      {estados && estados.map((estado) => (
                        <option key={estado.id} value={estado.id}>{estado.nombre}</option>
                      ))}
                    </select>
                    <label htmlFor="floatingEstado">Estado o Provincia</label>
                  </div><div className='form-floating col-4 mb-3 pe-1 d-flex justify-content-between'>
                    <select id="floatingCiudad" className='form-select form-select-solid ' data-kt-select2='true' data-placeholder='Ciudad' data-allow-clear='true' data-kt-user-table-filter='Ciudad'
                      data-hide-search='true' value={ciudadSeleccionada || ''} onChange={handleCiudadChange} disabled={!ciudades}>
                      <option value="" disabled>Selecciona una ciudad</option>
                      {ciudades && ciudades.map((ciudad) => (
                        <option key={ciudad.id} value={ciudad.id}>{ciudad.nombre}</option>
                      ))}
                    </select>
                    <label htmlFor="floatingCiudad">Ciudad</label>
                  </div>
                </>
              }

            </div>
            <div className="form-floating col-12 mb-3 d-flex justify-content-between">
              {sucursalSeleccionada !== "" ?
                <>
                  <textarea value={direccion} className="form-control text-start fs-5 form-control-solid" disabled
                    style={{
                      overflow: 'hidden',
                      resize: 'none',
                    }}></textarea>
                  <label htmlFor="floatRazon">Dirección</label>
                </> :
                <>
                  <textarea value={direccionIngresada} onChange={e => setDireccionIngresada(e.target.value)} className="form-control text-start fs-5 form-control-solid" style={{
                    overflow: 'hidden',
                    resize: 'none',
                  }}></textarea>
                  <label htmlFor="floatRazon">Dirección</label>
                </>
              }
            </div>
          </div>
        </div>
        <div className='separator separator-dashed my-6'></div>

        {/* <ShoppingPage /> */}
        <div className='d-flex flex-row align-items-start justify-content-between'>
          <div className='d-flex align-items-start flex-row flex-wrap col-6' >
            {
              // items?.map(product => (
              //   <ProductCard
              //     key={product.id}
              //     product={product}
              //     className="bg-white text-gray d-flex flex-column align-self-center"
              //     onChange={onProductCountChange}
              //     value={shoppingCart[product.id!]?.count || 0}
              //     style={{ boxShadow: '0px 0px 5px rgba(0,0,0,0.2)' }}
              //   >
              //     <ProductNombre className="text-bold" />
              //     <ProductImage className="custom-image" />
              //     {/* <input></input> */}
              //     <ProductPrecio className="" />
              //     <ProductButtons className="custom-buttons" />
              //   </ProductCard>
              // ))

              items?.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  className="bg-white text-gray d-flex flex-column align-self-center"
                  onChange={onProductCountChange}
                  value={shoppingCart[product.id!]?.count || 0}
                  style={{ boxShadow: '0px 0px 5px rgba(0,0,0,0.2)' }}
                >
                  <ProductNombre className="text-bold px-3 pt-3" />
                  <ProductImage className="custom-image" />


                  {descuentosAplicados[product.id] !== undefined ? (
                    <>
                      <div className='d-flex flex-row justify-content-between px-3 pb-3'>
                        <span className="text-bold" >${descuentosAplicados[product.id!]?.nuevoPrecio.toFixed(2)}</span>
                        <ProductPrecio className="text-danger text-decoration-line-through" />

                        <span>{descuentosAplicados[product.id!]?.porcentaje}% de descuento</span>
                      </div></>
                  ) :
                    <ProductPrecio className="px-3 pb-3" />

                    // (null as unknown as React.ReactElement<any, string | JSXElementConstructor<any>>)
                  }



                  <ProductButtons className="custom-buttons" />
                  <div className='d-flex flex-row px-3'>
                    <input
                      type="text"
                      placeholder="Código de descuento"
                      value={codigosDescuento[product.id!] || ''}
                      onChange={(event) => handleCodigoDescuentoChange(product.id!, event)}
                      style={{
                        borderRadius: '5px 0 0 5px', // Redondear solo el lado derecho
                        backgroundColor: 'white',
                        color: 'black',
                        padding: '10px', // Ajusta según sea necesario
                        border: '1px solid gray', // Borde gris
                        whiteSpace: 'nowrap', // Evitar que el texto haga wrap
                        maxWidth: '170px'
                      }}
                    />
                    <button onClick={() => handleAplicarDescuento(product.id!, product)}
                      style={{
                        borderRadius: '0 5px 5px 0', // Redondear solo el lado derecho
                        backgroundColor: '#6c757d',
                        color: 'white',
                        padding: '10px', // Ajusta según sea necesario
                        cursor: 'pointer', // Cambia el cursor al pasar sobre el botón
                        border: 'none', // Elimina el borde si lo deseas
                        whiteSpace: 'nowrap', // Evitar que el texto haga wrap
                      }}> Aplicar
                      {/* <KTIcon iconName='discount' className='fs-1' /> */}
                    </button>
                  </div>
                </ProductCard>
              ))

            }
          </div>

          <div className='card-body shadow-sm py-1 mb-1 bg-body rounded mb-2 mb-xl-4 d-flex flex-column align-self-stretch'>
            <div className='card-header border-4 py-3 border-0 d-flex justify-content-center'>
              <h3 className='fw-bolder fs-1 m-0'> Pedido </h3>
            </div>
            <div className='card-body border-top p-2'>
              <table className="table table-solid gy-2 gs-2">
                <thead>
                  <tr className="fw-bold fs-5 text-gray-800 border-bottom border-gray-800">
                    <th className="m-0 p-0" style={{ textAlign: "left" }}>SKU</th>
                    <th className="m-0 p-0" style={{ textAlign: "left" }}>Producto</th>
                    <th className="m-0 p-0" style={{ textAlign: "left" }}>Precio</th>
                    <th className="m-0 p-0" style={{ textAlign: "left" }}>Descuento</th>
                    <th className="m-0 p-0" style={{ textAlign: "left" }}>Precio Final</th>
                    <th className="m-0 p-0" style={{ textAlign: "left" }}>Cantidad</th>
                    <th className="m-0 p-0 " style={{ textAlign: "right" }}>Total</th>
                  </tr>
                </thead>
                <tbody >
                  {ejemplo = Object.entries(shoppingCart).map(([key, product]) => (
                    <>
                      <tr className='fs-4'>
                        <td className='m-0 p-0 w-80px h-5px' style={{ textAlign: "left" }}>
                          <ProductCard key={key} product={product} className='w-80px h-5px m-0 p-0' style={{ padding: "0", margin: "0" }} onChange={onProductCountChange} value={product.count}>
                            <span>{product.sku}</span>
                          </ProductCard>
                        </td>
                        <td className='m-0 p-0 w-200px h-5px' style={{ textAlign: "left" }}>
                          <ProductCard key={key} product={product} className='w-200px h-5px m-0 p-0' style={{ padding: "0", margin: "0" }} onChange={onProductCountChange} value={product.count}>
                            <span>{product.nombre}</span>
                          </ProductCard>
                        </td>
                        <td className='m-0 p-0 w-60px h-5px' style={{ textAlign: "left" }}>
                          <ProductCard key={key} product={product} className='w-60px h-5px m-0 p-0' style={{ padding: "0", margin: "0" }} onChange={onProductCountChange} value={product.count}>
                            <span>{"$" + new Intl.NumberFormat().format((product.precio_lista!))}</span>
                          </ProductCard>
                        </td>
                        <td className='m-0 p-0 w-160px h-5px'>
                          <div className='d-flex flex-row'>
                            {descuentosAplicados[product.id] !== undefined ? descuentosAplicados[product.id!]?.porcentaje.toFixed(2) + "%" : "00.00%"}
                            &emsp;
                            <ProductCard key={key} product={product} className='w-80px h-5px m-0 p-0' onChange={onProductCountChange} value={product.count}>
                              <>
                                {descuentosAplicados[product.id] !== undefined ?
                                  ("-$" + (product.precio_lista! - descuentosAplicados[product.id!]?.nuevoPrecio!).toFixed(2))
                                  :
                                  "$0.00"}
                              </>
                            </ProductCard>
                          </div>
                        </td>
                        <td className='m-0 p-0 w-160px h-5px'>
                          {descuentosAplicados[product.id] !== undefined ?
                            "$" + descuentosAplicados[product.id!]?.nuevoPrecio.toFixed(2)
                            :
                            <ProductCard key={key} product={product} className='w-60px h-5px m-0 p-0' style={{ padding: "0", margin: "0" }} onChange={onProductCountChange} value={product.count}>
                              <span>{"$" + new Intl.NumberFormat().format(product.precio_lista!)}</span>
                            </ProductCard>}
                        </td>
                        <td className='m-0 p-0 w-75px h-5px'>
                          <ProductCard key={key} product={product} className='w-75px h-5px m-0 p-0' onChange={onProductCountChange} value={product.count}>
                            <span>{product.count}</span>
                          </ProductCard>
                        </td>
                        <td className='m-0 p-0 w-80px h-5px' align='right'>
                          <ProductCard key={key} product={product} className='w-80px h-5px m-0 p-0' onChange={onProductCountChange} value={product.count}>
                            <>
                              {descuentosAplicados[product.id] !== undefined ?
                                ("$" + (descuentosAplicados[product.id!]?.nuevoPrecio! * product.count).toFixed(2))
                                :
                                ("$" + (product.count * product.precio_lista!).toFixed(2))}
                            </>
                          </ProductCard>
                          {/* <ProductCard key={key} product={product} className='w-80px h-5px m-0 p-0' onChange={onProductCountChange} value={product.count}>
                            <span>{"$" + new Intl.NumberFormat().format(product.count * product.precio_lista!)}</span>
                          </ProductCard> */}
                        </td>
                      </tr >
                    </>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='card-footer d-flex flex-column py-3 px-3 d-flex justify-content-between'>
              <div className='d-flex flex-row justify-content-end'>
                <div className='col-3'>
                  <h4> Descuento en Cupones</h4>
                </div>
                <div className='col-2 d-flex justify-content-end'>
                  <h4>{descuentoCupones !== 0 ? ('-' + new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(descuentoCupones)) : "$0.00"}</h4>
                </div>
              </div>
              <div className='d-flex flex-row justify-content-end'>
                <div className='col-3'>
                  <h4> Subtotal</h4>
                </div>
                <div className='col-2 d-flex justify-content-end'>
                  <h4>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(subtotal)}</h4>
                </div>
              </div>
              <div className='d-flex flex-row justify-content-end'>
                <div className='col-3'>
                  <h4> Descuento de Cliente</h4>
                </div>
                <div className='col-2 d-flex justify-content-end'>
                  <h4>{descuentoFinal !== 0 ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(descuentoFinal)) : "$0.00"}</h4>
                </div>
              </div>
              <div className='d-flex flex-row justify-content-between'>
                <h1>Total </h1>
                <h1>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</h1>
              </div>
            </div>
          </div>
        </div>

        <div className='separator separator-dashed my-6'></div>

        {/* Botón de Crear Orden */}
        <div className='d-flex justify-content-end mt-5'>
          {ciudades && paises && direccion ?
            <button type='button' onClick={updateConfig} className='btn btn-primary me-2'>
              {!configLoading && <span className='indicator-label'>Generar Orden</span>}
              {configLoading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Creando Orden...{' '}

                </span>
              )}
            </button>
            :
            <button type='button' onClick={updateConfig} className='btn btn-primary me-2' disabled>
              {!configLoading && <span className='indicator-label'>Generar Orden</span>}
              {configLoading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Creando Orden...{' '}

                </span>
              )}
            </button>}
        </div>

      </div >
    </>
  )
}

export { ListProduct }
